// extracted by mini-css-extract-plugin
module.exports = {"main":"PaddingContainer_main__9E2ix"};